// Constants for standard Cognito attributes
export const StandardCognitoAttributes = {
  GivenName: 'given_name',
  FamilyName: 'family_name',
  Email: 'email',
};
